
export const sound_explanation = (
  <>
USES &quot;db&quot; DEFINITIONS! NOT SIMPLE NUMBERS.<br/>
Volume of the sound compared to other sounds.
Sounds with higher volume make other sounds quietter.<br/>
In OFP sounds can be heard from any distance,
but their &quot;silencing&quot; effect lowers on higher distances.<br/>
Vanila examples:
    <ul>
      <li>Gun rotation &mdash;&gt; -40</li>
      <li>Cars &mdash;&gt; -30</li>
      <li>Trucks &mdash;&gt; -20</li>
      <li>Tanks &mdash;&gt; -10</li>
      <li>Weapons &mdash;&gt; -0</li>
      <li>Helicopters &mdash;&gt; +10</li>
      <li>Cannons &mdash;&gt; +20</li>
      <li>Explosions &mdash;&gt; +40</li>
    </ul>
  </>
);

export const pitch_explanation = (
  <>
Pitch of the sound.
  </>
);

export const fileSound_explanation = (
  <>
Path to sound.<br/>
Only sounds inside mission folder can be accessed.<br/>
Has to start with &quot;\&quot;, but can me omitted.</>
);

export const soundName_explanation = (
  <>Name inside trigger effects.</>
);

export const soundKeepName_explanation = (
  <>Unused</>
);